import React from 'react';
import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { useApplyTitleStyle } from './logic';

export const CardContentTitle = ({
  children,
  className,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  const titleClassNames = useApplyTitleStyle();

  return (
    <Component
      className={classNames(
        'CardContentTitle',
        className,
        'font-medium',
        titleClassNames,
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
